import getCountryFromUrl from "@RHCommerceDev/utils/getCountryFromUrl";
import { NA_COUNTRIES } from "@RHCommerceDev/utils/constants";

export const useIsNA = () => {
  const country = getCountryFromUrl();
  return NA_COUNTRIES.includes(country);
};
